import { render, staticRenderFns } from "./file-choose-button.vue?vue&type=template&id=4676fc5a&"
import script from "./file-choose-button.vue?vue&type=script&lang=ts&"
export * from "./file-choose-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4676fc5a')) {
      api.createRecord('4676fc5a', component.options)
    } else {
      api.reload('4676fc5a', component.options)
    }
    module.hot.accept("./file-choose-button.vue?vue&type=template&id=4676fc5a&", function () {
      api.rerender('4676fc5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/file/file-choose-button.vue"
export default component.exports